import type { GenericPanelData } from 'features/drilldown'
import type { NiiSheetKey } from 'features/libra/stepComponents/niiReport/sheet/niiSheetSelection'

/**
 * Lives apart from the panel and its config view so both can import the shape
 * without importing each other (same split as `valueListFilterPanelData`).
 *
 * The column choice is stored as exclusions, so columns a workflow gains
 * later show up in saved explorations instead of silently going missing.
 */
export interface NiiReportSheetExportPanelData extends GenericPanelData {
  excludedSheets?: ReadonlyArray<NiiSheetKey>
  excludedColumns?: Partial<Record<NiiSheetKey, ReadonlyArray<string>>>
  /** Export in-progress tickets too. Absent means completed only. */
  includeIncomplete?: boolean
}

export const LATEST_NII_REPORT_SHEET_EXPORT_PANEL_DATA_SCHEMA_VERSION = 1

export const DEFAULT_NII_REPORT_SHEET_EXPORT_PANEL_DATA: NiiReportSheetExportPanelData =
  {
    panelDataSchemaVersion:
      LATEST_NII_REPORT_SHEET_EXPORT_PANEL_DATA_SCHEMA_VERSION,
    title: 'NII Ticket Spreadsheet Export',
    isPinned: false,
  }
